import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

axios.defaults.withCredentials = true;
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = authed
  const [stats, setStats] = useState(null);

  const refreshStats = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/auth/stats`);
      setStats(data);
    } catch { /* ignore */ }
  }, []);

  const checkAuth = useCallback(async () => {
    if (window.location.hash?.includes("session_id=")) { setUser(false); return; }
    try {
      const { data } = await axios.get(`${API}/auth/me`);
      setUser(data);
    } catch {
      setUser(false);
    }
    refreshStats();
  }, [refreshStats]);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    setUser(data); refreshStats(); return data;
  };
  const register = async (email, password, name) => {
    const { data } = await axios.post(`${API}/auth/register`, { email, password, name });
    setUser(data); refreshStats(); return data;
  };
  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`); } catch { /* ignore */ }
    setUser(false); refreshStats();
  };
  const setAuthed = (u) => { setUser(u); refreshStats(); };

  return (
    <AuthCtx.Provider value={{ user, stats, login, register, logout, checkAuth, refreshStats, setAuthed }}>
      {children}
    </AuthCtx.Provider>
  );
}
